import React, { useContext, useState } from "react";
import styles from "./PainelControle.module.css";
import { PedidosContext } from "../../../shared/contexts/PedidosContext";
import CardUltimosPedidos from "../../../shared/components/CardUltimosPedidos";
import HeaderPageEquipe from "../components/HeaderPageEquipe";
import FooterOpcoes from "../../cliente/components/FooterOpcoes";
import { FaBoxOpen } from "react-icons/fa";
import { FiClock } from "react-icons/fi";
import { numeroExibicaoPedido } from "../../../shared/utils/pedido";

const STATUS_TILES = [
  { key: "pendente", label: "Pendente", cor: "#c7222a", bg: "#fdeeee" },
  { key: "em andamento", label: "Andamento", cor: "#c9861f", bg: "#fff6e8" },
  { key: "pronto", label: "Pronto", cor: "#2f8f5b", bg: "#eaf7f0" },
  { key: "entregue", label: "Entregue", cor: "#6b7280", bg: "#f1f2f4" },
];

function PainelControle() {
  const { pedidos, setPedidos, atualizarPedidos } = useContext(PedidosContext);
  const [filterType, setFilterType] = useState("");
  const [filterNext20Min, setFilterNext20Min] = useState(false); // filtro próximos 20 minutos
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [codigoDigitado, setCodigoDigitado] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);

  // Abre modal para digitar o código
  const abrirModalCodigo = (pedido) => {
    setPedidoSelecionado(pedido);
    setCodigoDigitado("");
    setMostrarModal(true);
  };

  const fecharModal = () => {
    setMostrarModal(false);
    setPedidoSelecionado(null);
  };

  // Confirmar o código e enviar ao backend
  const confirmarCodigoEntrega = async () => {
    if (!codigoDigitado) {
      alert("Por favor, digite o código de entrega.");
      return;
    }

    await mudarStatusPedido(pedidoSelecionado.id_pedido, "entregue", codigoDigitado);
    fecharModal();
  };

  // Função geral para mudar o status
  const mudarStatusPedido = async (id_pedido, novoStatus, codigoDigitado = null) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;

      const response = await fetch(`${API_URL}/atualizar-item`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ numPedido: id_pedido, novoStatus, codigoDigitado }),
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Erro ao atualizar status.");
        return;
      }

      if (data.success) {
        const pedidoAtualizado = pedidos.find((p) => p.id_pedido === id_pedido);
        alert(`Pedido ${pedidoAtualizado ? numeroExibicaoPedido(pedidoAtualizado) : id_pedido} atualizado para ${novoStatus}.`);
        const novosPedidos = pedidos.map((pedido) =>
          pedido.id_pedido === id_pedido ? { ...pedido, status: novoStatus } : pedido
        );
        setPedidos(novosPedidos);
      } else {
        alert(data.message || "Erro ao atualizar pedido.");
        // Sincroniza o estado com o banco para corrigir status desatualizado
        await atualizarPedidos();
      }
    } catch (error) {
      console.error("Erro de comunicação com o backend:", error);
      alert("Erro de comunicação com o servidor. Tente novamente.");
      await atualizarPedidos();
    }
  };

  // Filtrar pedidos
  const pedidosFiltrados = pedidos.filter((pedido) => {
    // filtro por status
    if (filterType && pedido.status !== filterType) return false;

    // filtro próximos 20 minutos
    if (filterNext20Min) {
      const agora = new Date();
      const dataHoraEntrega = new Date(`${pedido.data_agendada}T${pedido.hora_agendada}`);
      const diffMinutos = (dataHoraEntrega - agora) / (1000 * 60);
      if (!(diffMinutos >= 0 && diffMinutos <= 20)) return false;
    }

    // filtro por número do pedido (o número que aparece na tela, não o id do banco)
    if (codigoDigitado && !String(numeroExibicaoPedido(pedido)).includes(codigoDigitado)) return false;

    return true;
  });

  const selecionarStatus = (chave) => {
    setFilterNext20Min(false);
    setFilterType((atual) => (atual === chave ? "" : chave));
  };

  const limparFiltros = () => {
    setFilterType("");
    setFilterNext20Min(false);
  };

  const filtroAtivo = filterNext20Min || filterType;
  const tituloLista = filterNext20Min
    ? "Próximos 20 minutos"
    : filterType
    ? STATUS_TILES.find((t) => t.key === filterType)?.label
    : "Todos os pedidos";

  const nomeEstabelecimento = localStorage.getItem("nomeEstabelecimento");
  // Estabelecimentos do tipo restaurante (sem universidade vinculada) entregam na mesa,
  // sem código de retirada
  const isRestaurante = !localStorage.getItem('id_universidade');

  return (
    <div className={styles.painel_controle}>
      <HeaderPageEquipe
        nomeEstabelecimento={nomeEstabelecimento}
        nomePage="Painel de Controle"
      />

      <div className={styles.buscaCard}>
        <input
          type="text"
          placeholder="Buscar por número do pedido..."
          value={codigoDigitado}
          onChange={(e) => setCodigoDigitado(e.target.value)}
          className={styles.buscaInput}
        />
      </div>

      {/* Contadores por status — também funcionam como filtro */}
      <p className={styles.filtrosLabel}>Filtrar por status</p>
      <div className={styles.statFilterGrid}>
        {STATUS_TILES.map((tile) => {
          const contagem = pedidos.filter((p) => p.status === tile.key).length;
          const ativo = filterType === tile.key;
          return (
            <button
              key={tile.key}
              className={`${styles.statFilterTile} ${ativo ? styles.tileAtivo : ""}`}
              style={ativo ? { borderColor: tile.cor, background: tile.bg } : undefined}
              onClick={() => selecionarStatus(tile.key)}
            >
              <span className={styles.tileNumero}>{contagem}</span>
              <span className={styles.tileLabel}>
                <span className={styles.tileDot} style={{ background: tile.cor }} />
                {tile.label}
              </span>
            </button>
          );
        })}
      </div>

      <button
        className={`${styles.toggle20min} ${filterNext20Min ? styles.toggle20minAtivo : ""}`}
        onClick={() => { setFilterType(""); setFilterNext20Min(!filterNext20Min); }}
      >
        <FiClock size={13} /> Próximos 20 minutos
      </button>

      {/* Seção de Pedidos */}
      <section className={styles.pedidosSection}>
        {pedidosFiltrados.length === 0 ? (
          <div className={styles.containerNenhumPedido}>
            <FaBoxOpen className={styles.icone} />
            <p className={styles.texto}>
              <span className={styles.oops}>Oops!</span>
              Nenhum pedido encontrado com os filtros selecionados
            </p>
          </div>
        ) : (
          <>
            <div className={styles.pedidosHeader}>
              <h3 className={styles.pedidosTitulo}>
                {tituloLista}
                <span className={styles.pedidosCount}>{pedidosFiltrados.length}</span>
              </h3>
              {filtroAtivo && (
                <button className={styles.btnVerTodos} onClick={limparFiltros}>Ver todos</button>
              )}
            </div>
            <div className={styles.listaPedidos}>
              {pedidosFiltrados.map((pedido) => (
                <CardUltimosPedidos
                  key={pedido.id_pedido}
                  pedido={pedido}
                  mostrarClienteEStatus={true}
                  exibirMeta={true}
                  mudarStatusPedido={(id, status) => {
                    if (status.toLowerCase() === "entregue" && !isRestaurante) {
                      abrirModalCodigo(pedido);
                    } else {
                      mudarStatusPedido(id, status);
                    }
                  }}
                />
              ))}
            </div>
          </>
        )}
      </section>

      <FooterOpcoes typeView="equipe" />

      {/* MODAL DE CONFIRMAÇÃO */}
      {mostrarModal && (
        <div className={styles.modalOverlay} onClick={fecharModal}>
          <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
            <h3>Confirmar Entrega</h3>
            <p>Digite o código de 4 dígitos informado ao cliente para confirmar a entrega do pedido.</p>
            <input
              type="text"
              value={codigoDigitado}
              onChange={(e) => setCodigoDigitado(e.target.value.toUpperCase())}
              className={styles.inputCodigo}
              maxLength={4}
              placeholder="----"
              autoFocus
            />
            <div className={styles.modalButtons}>
              <button onClick={confirmarCodigoEntrega} className={styles.btnConfirmar}>
                Confirmar
              </button>
              <button onClick={fecharModal} className={styles.btnCancelar}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PainelControle;
